// src/routes/Routes.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Login from "../components/auth/login/Login";
import Dashboard from "../pages/dashboard/Dashboard";
import ForgotPassword from "../components/auth/forgotPassword/ForgotPassword";
import Navbar from "../components/navbar/Navbar";
import ConsumerList from "../pages/ConsumerList/ConsumerList";
import Footer from "../components/footer/Footer";
import ConsumerProfile from "../pages/ConsumerList/ConsumerProfile";
import EditInfo from "../pages/ConsumerList/EditInfo";
import Wallet from "../pages/ConsumerList/Wallet";
import ScheduledAppointmentDetail from "../pages/ConsumerList/ScheduledAppointmentDetail";
import CompletedAppointmentDetail from "../pages/ConsumerList/CompletedAppointmentDetail";
import CancelledAppointmentDetail from "../pages/ConsumerList/CancelledAppointmentDetail";
import ProviderList from "../pages/ProviderList/ProviderList";
import PendingRegistration from "../pages/ProviderList/PendingRegistration";
import ProfileReview from "../pages/ProviderList/ProfileReview";
import EditProviderInfo from "../pages/ProviderList/EditProviderInfo";
import ProviderProfile from "../pages/ProviderList/ProviderProfile";
import TotalEarning from "../pages/ProviderList/TotalEarning";
import ViewAllReview from "../pages/ProviderList/ViewAllReview";
import CompletedAppointmentList from "../pages/ProviderList/CompletedAppointmentList";
import CompletedPatientDetail from "../pages/ProviderList/CompletedPatientDetail";
import ScheduledAppointmentList from "../pages/ProviderList/ScheduledAppointmentList";
import ScheduledPatientDetail from "../pages/ProviderList/ScheduledPatientDetail";
import CancelledAppointmentList from "../pages/ProviderList/CancelledAppointmentList";
import PendingRequestList from "../pages/ProviderList/PendingRequestList";
import PendingPatientDetail from "../pages/ProviderList/PendingPatientDetail";
import DeclinedAppointmentList from "../pages/ProviderList/DeclinedAppointmentList";
import DeclinedPatientDetail from "../pages/ProviderList/DeclinedPatientDetail";
import Advertisement from "../pages/advertisement/Advertisement";
import Support from "../pages/support/Support";
import Notifications from "../pages/notifications/Notifications";
import Profile from "../pages/profile/Profile";
import NotFound from "../components/404/NotFound";
import Transactions from "../pages/Transactions/Transactions";
import { useCookies } from "react-cookie";
import WithdrawRequest from "../pages/WithdrawRequest/WithdrawRequest";
import Offer from "../pages/Offer/Offer";
import ChangePasswordPage from "../pages/ChangePasswordPage/ChangePasswordPage";

const AppRoutes = () => {
  const [cookies] = useCookies(["reebukToken"]);

  return (
    <Routes>
      {/* Redirect "/" to "/auth/Login" */}
      {!cookies.reebukToken ? (
        <Route path="/" element={<Navigate to="/auth/Login" replace />} />
      ) : (
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      )}

      {/* login route */}
      {!cookies.reebukToken ? (
        <Route exact path="/auth/Login" element={<Login />} />
      ) : (
        <Route
          path="/auth/Login"
          element={<Navigate to="/dashboard" replace />}
        />
      )}
      <Route exact path="/auth/forgotPassword" element={<ForgotPassword />} />

      {/* list of  protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route
          exact
          path="/dashboard"
          element={
            <>
              <Navbar />
              <Dashboard />
            </>
          }
        />
        <Route
          exact
          path="/withdraw"
          element={
            <>
              <Navbar />
              <WithdrawRequest />
            </>
          }
        />
        <Route
          exact
          path="/offers"
          element={
            <>
              <Navbar />
              <Offer />
            </>
          }
        />
        <Route
          exact
          path="/consumer"
          element={
            <div className="min-h-screen">
              <Navbar />
              <ConsumerList />
              <Footer />
            </div>
          }
        />
        <Route
          exact
          path="/consumerProfile/:id"
          element={
            <>
              <Navbar />
              <ConsumerProfile />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/editProfile"
          element={
            <>
              <Navbar />
              <EditInfo />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/change-password"
          element={
            <>
              <Navbar />
              <ChangePasswordPage />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/consumerProfile/wallet/:id"
          element={
            <>
              <Navbar />
              <Wallet />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/scheduledAppointmentDetail"
          element={
            <>
              <Navbar />
              <ScheduledAppointmentDetail />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/completedAppointmentDetail"
          element={
            <>
              <Navbar />
              <CompletedAppointmentDetail />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/cancelledAppointmentDetail"
          element={
            <>
              <Navbar />
              <CancelledAppointmentDetail />
              <Footer />
            </>
          }
        />
        {/* provider route */}
        <Route
          exact
          path="/provider"
          element={
            <>
              <Navbar />
              <ProviderList />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/providerProfile"
          element={
            <>
              <Navbar />
              <ProviderProfile />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/providerProfile/wallet/:id"
          element={
            <>
              <Navbar />
              <Wallet />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/PendingRegistration"
          element={
            <>
              <Navbar />
              <PendingRegistration />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/ProfileReview"
          element={
            <>
              <Navbar />
              <ProfileReview />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/EditProviderInfo"
          element={
            <>
              <Navbar />
              <EditProviderInfo />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/totalEarning"
          element={
            <>
              <Navbar />
              <TotalEarning />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/viewAllReview"
          element={
            <>
              <Navbar />
              <ViewAllReview />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/completedAppointments"
          element={
            <>
              <Navbar />
              <CompletedAppointmentList />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/completedPatientDetail"
          element={
            <>
              <Navbar />
              <CompletedPatientDetail />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/scheduledAppointments"
          element={
            <>
              <Navbar />
              <ScheduledAppointmentList />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/scheduledPatientDetail"
          element={
            <>
              <Navbar />
              <ScheduledPatientDetail />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/cancelledAppointments"
          element={
            <>
              <Navbar />
              <CancelledAppointmentList />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/cancelledPatientDetail"
          element={
            <>
              <Navbar />
              <CancelledAppointmentDetail />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/pendingRequest"
          element={
            <>
              <Navbar />
              <PendingRequestList />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/pendingPatientDetail"
          element={
            <>
              <Navbar />
              <PendingPatientDetail />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/declinedAppointment"
          element={
            <>
              <Navbar />
              <DeclinedAppointmentList />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/declinedPatientDetail"
          element={
            <>
              <Navbar />
              <DeclinedPatientDetail />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/advertisement"
          element={
            <>
              <Navbar />
              <Advertisement />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/support"
          element={
            <>
              <Navbar />
              <Support />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/notifications"
          element={
            <>
              <Navbar />
              <Notifications />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/profile"
          element={
            <>
              <Navbar />
              <Profile />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path="/transactions"
          element={
            <>
              <Navbar />
              <Transactions />
              <Footer />
            </>
          }
        />
      </Route>

      {/* Catch-all for non-existing routes */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
